import { render } from "./SetupTwoFactor.vue?vue&type=template&id=2ec02177&scoped=true"
import script from "./SetupTwoFactor.vue?vue&type=script&lang=js"
export * from "./SetupTwoFactor.vue?vue&type=script&lang=js"

import "./SetupTwoFactor.vue?vue&type=style&index=0&id=2ec02177&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec02177"]])

export default __exports__